import React, { useState } from "react";
import { FaPhoneSquareAlt, FaInstagram, FaYoutube } from "react-icons/fa";

const Index = () => {
  const phoneNumbers = [
    { number: "9844771360", label: "Vignesh Raju" },
    { number: "7075204094", label: "Durga Rama Prasad" },
    { number: "9492487107", label: "Sujan Kumar" },
  ];

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <footer
      className="relative bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 
      text-white py-10 shadow-inner"
      id="contact"
    >
      {/* Glow effect */}
      <div className="absolute inset-0 bg-gradient-to-t from-purple-900/20 to-transparent pointer-events-none"></div>

      <div className="container mx-auto flex flex-col items-center relative z-10">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-extrabold mb-6 tracking-wide bg-clip-text text-transparent bg-gradient-to-r from-pink-400 via-purple-400 to-indigo-400">
          Contact Us
        </h2>

        {/* Icons Section */}
        <div className="flex justify-center space-x-10 mb-12">
          {/* Phone Dropdown */}
          <div className="relative">
            <button
              onClick={toggleDropdown}
              aria-label="Phone"
              className="text-4xl hover:text-green-400 transition-transform transform hover:scale-125"
            >
              <FaPhoneSquareAlt />
            </button>

            {/* Dropdown */}
            {isDropdownOpen && (
              <div
                className="absolute top-12 left-1/2 -translate-x-1/2 md:w-64 
                bg-gray-900/95 border border-purple-500/40 text-white rounded-xl shadow-xl
                animate-fadeIn overflow-hidden"
              >
                {phoneNumbers.map((phone, index) => (
                  <a
                    key={index}
                    href={`tel:${phone.number}`}
                    className="flex items-center justify-between px-4 py-2 hover:bg-purple-700/60 transition"
                  >
                    <span className="font-medium">{phone.label}</span>
                    <span className="text-sm opacity-80">{phone.number}</span>
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Instagram */}
          <a
            href="https://www.instagram.com/yantra_2k25_?igsh=YjQ1eDBjMG80eXl0"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
            className="text-4xl hover:text-pink-400 transition-transform transform hover:scale-125"
          >
            <FaInstagram />
          </a>

          {/* YouTube */}
          <a
            href="https://youtube.com/@yantra2k25?si=FOYWwUIywfRa9uif"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="YouTube"
            className="text-4xl hover:text-red-500 transition-transform transform hover:scale-125"
          >
            <FaYoutube />
          </a>
        </div>

        {/* Divider */}
        <div className="w-3/4 border-t border-gray-600 mb-6"></div>

        {/* Copyright */}
        <p className="text-center text-sm md:text-base font-semibold text-gray-300">
          © 2025 <span className="text-purple-400">Yantra 2k25</span>. All
          Rights Reserved.
        </p>
      </div>
    </footer>
  );
};

export default Index;
